import { useContactsQuotaQuery } from "../queries/useContactsQuotaQuery";
import type { ContactsQuotaState, QuotaOperationState } from "../types";

const DEFAULT_QUOTA: QuotaOperationState = { used: 0, remaining: 0, total: 0 };

type HookResult = ContactsQuotaState & {
    isLoading: boolean;
};

export const useContactsQuota = (enabled?: boolean): HookResult => {
    const { data = DEFAULT_QUOTA, isFetching } = useContactsQuotaQuery(enabled);

    return {
        data,
        isQuotaReached: data.remaining <= 0,
        isLoading: isFetching,
    };
};
